import { BookingMode } from "../enums/BookingScope";
import { FacilityType } from "../enums/FacilityType";
import { CompleteBooking } from "./Booking";
import { Sport } from "./Sport";
import { FullUserDTO, UserDTO } from "./User";

export type Structure = {
  id: string;
  name: string;
  address: string;
  cap: number;
  city: string;
  province: string;
  latitude: number;
  longitude: number;
  parentId: string;
  contactPhone?: string;
  contactEmail?: string;
  imageUrl?: string;
  preference?: BookingMode;
  active?: boolean;
  contractUrl?: string;
};

// Payload dell'endpoint unificato di registrazione struttura (solo admin):
// utenza (email+password) + proprietario + struttura + dati di fatturazione.
export type RegisterStructureDTO = {
  email: string;
  password: string;
  owner: {
    name: string;
    familyName: string;
    gender?: number;
    birthDate?: string;
  };
  structure: {
    name: string;
    address: string;
    cap: string;
    city: string;
    province: string;
    latitude: string;
    longitude: string;
    contactPhone?: string;
    contactEmail?: string;
  };
  billing: {
    name: string;
    vatCode: string;
    pec: string;
    uniCode: string;
  };
};

export type StructureCoach = {
  structureId: string;
  userId: string;
  structure: Structure;
  user: UserDTO;
};

export class Facility {
  id?: string;
  structureId: string;
  name: string;
  type: FacilityType;
  sportId: number;
  facilityImageUrl?: string;
  timeSlots: Array<WeeklySchedule>;
  bookings?: CompleteBooking[];
  structure?: Structure;
  sport?: Sport;

  constructor(facility?: Facility) {
    this.structureId = facility?.structureId || "";
    this.name = facility?.name || "";
    this.type = facility?.type || FacilityType.Outdoor;
    this.sportId = facility?.sportId || 1;
    this.timeSlots = facility?.timeSlots || [];
    this.structure = facility?.structure;
    this.sport = facility?.sport;
  }
}

export type ExtendedFacility = {
  id: string;
  structureId: string;
  name: string;
  type: FacilityType;
  sportId: number;
  timeSlots: Array<WeeklySchedule>;
  facilityImageUrl?: string;
  structure: Structure;
  sport: Sport;
};

export type TimeSlot = {
  time: string;
  maxBookings: number;
};

export type WeeklySchedule = {
  dayOfWeek: number;
  enabled: boolean;
  slots: TimeSlot[];
};

export type UserFavorites = {
  userId: string;
  email?: string;
  structureId: string;
  sportId: number;
  user: FullUserDTO;
  structure: Structure;
  sport: Sport;
};

export type UserFavoritesGrouped = {
  sport: Sport;
  favorites: UserFavorites[];
};

export type UserFavoriteDTO = {
  userId: string;
  structureId: string;
  sportId: number;
};

export type GetUserFavoriteDTO = {
  userId?: string;
  structureId?: string;
  sportId?: string;
};
